import type { SvgIconComponent } from '@mui/icons-material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import { PRODUCT_PAGES } from './productPages';

export type ClientPageSlug = 'medios' | 'agencias' | 'avisador';

export type ClientSolutionCard = {
    id: string;
    label: string;
    description: string;
    to: string;
    Icon: SvgIconComponent;
};

export type ClientPageContent = {
    slug: ClientPageSlug;
    path: string;
    navLabel: string;
    eyebrow: string;
    title: string;
    explainer: string;
    solutions: ClientSolutionCard[];
    footerCta: {
        title: string;
        ctaLabel: string;
        ctaTo: string;
    };
};

export const CLIENT_PAGES: Record<ClientPageSlug, ClientPageContent> = {
    medios: {
        slug: 'medios',
        path: '/cliente/medios',
        navLabel: 'Medios',
        eyebrow: 'Medios',
        title: 'Podscope para medios y productoras',
        explainer:
            'Cada mes armas el reporte para tus auspiciadores a mano, revisando episodio por episodio. Podscope detecta cada mención de marca automáticamente en tus episodios y en tus clips de YouTube Shorts, Instagram y TikTok, y te entrega el reporte listo, con prueba concreta de lo que entregaste.',
        solutions: [
            {
                id: 'reporteria',
                label: 'Reportería',
                description:
                    'Convierte cada mención detectada en un reporte exportable, listo para enviar a tu avisador.',
                to: PRODUCT_PAGES.reporteria.path,
                Icon: AssessmentOutlinedIcon,
            },
            {
                id: 'inteligencia',
                label: 'Inteligencia de mercado',
                description:
                    'Compara tu canal con el resto del ecosistema, cuántas marcas activas tienes vs. la competencia, semana a semana.',
                to: PRODUCT_PAGES.inteligencia.path,
                Icon: TravelExploreOutlinedIcon,
            },
        ],
        footerCta: {
            title: 'Deja de armar reportes a mano',
            ctaLabel: 'Agenda una demo',
            ctaTo: '/agenda-demo',
        },
    },
    agencias: {
        slug: 'agencias',
        path: '/cliente/agencias',
        navLabel: 'Agencias',
        eyebrow: 'Agencias',
        title: 'Podscope para agencias',
        explainer:
            'Rastrear el mercado digital a mano, qué marcas están en qué canal, cómo le va a cada programa, quién ganó terreno esta semana, no escala. Podscope te muestra el ecosistema completo con métricas por programa, y te deja confirmar de forma independiente lo que cada medio te reporta.',
        solutions: [
            {
                id: 'inteligencia',
                label: 'Inteligencia de mercado',
                description:
                    'Qué marcas están activas, en qué categoría, y qué canal o programa está ganando o perdiendo terreno cada semana.',
                to: PRODUCT_PAGES.inteligencia.path,
                Icon: TravelExploreOutlinedIcon,
            },
            {
                id: 'verificacion',
                label: 'Verificación',
                description:
                    'Confirma con un tercero independiente que la mención ocurrió, con el segundo exacto.',
                to: PRODUCT_PAGES.verificacion.path,
                Icon: AccessTimeOutlinedIcon,
            },
        ],
        footerCta: {
            title: 'Ve el mercado completo',
            ctaLabel: 'Agenda una demo',
            ctaTo: '/agenda-demo',
        },
    },
    avisador: {
        slug: 'avisador',
        path: '/cliente/avisador',
        navLabel: 'Avisador',
        eyebrow: 'Avisador',
        title: 'Podscope para avisadores',
        explainer:
            'Un medio te dice que tu marca apareció en tal episodio. Podscope lo confirma de forma independiente, con el segundo exacto y el alcance real de esa aparición.',
        solutions: [
            {
                id: 'verificacion',
                label: 'Verificación',
                description:
                    'Confirma cada mención reportada, con timestamp exacto y alcance real de esa aparición.',
                to: PRODUCT_PAGES.verificacion.path,
                Icon: AccessTimeOutlinedIcon,
            },
            {
                id: 'inteligencia',
                label: 'Inteligencia de mercado',
                description: 'Ve dónde está tu competencia y qué categorías dominan el ecosistema.',
                to: PRODUCT_PAGES.inteligencia.path,
                Icon: TravelExploreOutlinedIcon,
            },
        ],
        footerCta: {
            title: 'Verifica lo que te reportan',
            ctaLabel: 'Agenda una demo',
            ctaTo: '/agenda-demo',
        },
    },
};

export const CLIENT_TYPE_NAV_ITEMS: {
    label: string;
    to: string;
    Icon: SvgIconComponent;
}[] = [
    {
        label: CLIENT_PAGES.medios.navLabel,
        to: CLIENT_PAGES.medios.path,
        Icon: MicNoneOutlinedIcon,
    },
    {
        label: CLIENT_PAGES.agencias.navLabel,
        to: CLIENT_PAGES.agencias.path,
        Icon: BusinessCenterOutlinedIcon,
    },
    {
        label: CLIENT_PAGES.avisador.navLabel,
        to: CLIENT_PAGES.avisador.path,
        Icon: CampaignOutlinedIcon,
    },
];
